var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel__left"},[_c('p',[_vm._v("Найдено "+_vm._s(_vm.numberFormat(_vm.sidesNumber, 0, '.', ' '))+" сторон")])])])}
var staticRenderFns = []

export { render, staticRenderFns }